const fonts = {
  GTAmericaRegular: '\'GTAmerica-Regular\', Sans-Serif',
  MabryProRegular: '\'mabry-pro-regular\', Sans-Serif',
  MabryProMedium: '\'mabry-pro-medium\', Sans-Serif',
  InterRegular: '\'inter-regular\', Sans-Serif'
};
const fontStyles = {
  displays: {
    xLarge: {
      fontSizeMin: 60,
      fontSizeMax: 150,
      lineHeight: 1,
      letterSpacing: -0.03
    },
    large: {
      fontSizeMin: 55,
      fontSizeMax: 118,
      lineHeight: 1,
      letterSpacing: -0.02
    },
    medium: {
      fontSizeMin: 34,
      fontSizeMax: 82,
      lineHeight: 1.2,
      letterSpacing: -0.015
    },
    small: {
      fontSizeMin: 28,
      fontSizeMax: 56,
      lineHeight: 1.2,
      letterSpacing: -0.01
    }
  },
  buttons: {
    primary: {
      fontFamily: fonts.MabryProRegular,
      fontSizeMax: 18,
      fontSizeMin: 16,
      lineHeight: 1.25
    },
    secondary: {
      fontFamily: fonts.MabryProRegular,
      fontSizeMax: 18,
      fontSizeMin: 16,
      lineHeight: 1.25
    }
  },
  eyebrow: {
    fontFamily: fonts.MabryProRegular,
    fontSizeMax: 18,
    fontSizeMin: 16,
    fontWeight: 500,
    letterSpacing: 0.02,
    lineHeight: 1.25
  },
  headings: {
    h1: {
      fontSizeMin: 25,
      fontSizeMax: 44,
      lineHeight: 1.25,
      letterSpacing: -0.01,
      regular: {
        fontFamily: fonts.MabryProRegular
      },
      medium: {
        fontFamily: fonts.MabryProMedium
      }
    },
    h2: {
      fontSizeMin: 23,
      fontSizeMax: 37,
      lineHeight: 1.25,
      letterSpacing: -0.01,
      regular: {
        fontFamily: fonts.MabryProRegular
      },
      medium: {
        fontFamily: fonts.MabryProMedium
      }
    },
    h3: {
      fontSizeMin: 22,
      fontSizeMax: 32,
      lineHeight: 1.35,
      letterSpacing: -0.01,
      regular: {
        fontFamily: fonts.MabryProRegular
      },
      medium: {
        fontFamily: fonts.MabryProMedium
      }
    },
    h4: {
      fontSizeMin: 20,
      fontSizeMax: 28,
      lineHeight: 1.45,
      letterSpacing: -0.01,
      regular: {
        fontFamily: fonts.MabryProRegular
      },
      medium: {
        fontFamily: fonts.MabryProMedium
      }
    },
    h5: {
      fontSizeMin: 18,
      fontSizeMax: 24,
      lineHeight: 1.45,
      letterSpacing: -0.01,
      regular: {
        fontFamily: fonts.MabryProRegular
      },
      medium: {
        fontFamily: fonts.MabryProMedium
      }
    },
    h6: {
      fontSizeMin: 16,
      fontSizeMax: 21,
      lineHeight: 1.45,
      letterSpacing: -0.01,
      regular: {
        fontFamily: fonts.MabryProRegular
      },
      medium: {
        fontFamily: fonts.MabryProMedium
      }
    }
  },
  label: {
    fontFamily: fonts.InterRegular,
    fontSize: 12
  },
  paragraphs: {
    lg: {
      fontSizeMin: 17,
      fontSizeMax: 18.5,
      lineHeight: {
        normal: 1.5,
        large: 2
      }
    },
    md: {
      fontSizeMin: 16,
      fontSizeMax: 16,
      lineHeight: {
        normal: 1.5,
        large: 2
      }
    },
    sm: {
      fontSizeMin: 14,
      fontSizeMax: 14,
      lineHeight: {
        normal: 1.5,
        large: 2
      }
    },
    xs: {
      fontSizeMin: 12,
      fontSizeMax: 12,
      lineHeight: {
        normal: 1.5,
        large: 1.75
      }
    },
    xxs: {
      fontSizeMin: 10,
      fontSizeMax: 10,
      lineHeight: {
        normal: 1.75,
        large: 1.75
      }
    }
  },
  weights: {
    medium: 700,
    regular: 500
  }
};

export { fontStyles, fonts };
//# sourceMappingURL=Fonts.js.map
